import React from "react";

import PrintFinanceBars from "../common/PrintFinanceBars";

import lbl from "../../../data/Labels.json";

const Chart = ({ data }) => {
  const paid = Number(data?.summary?.total_paid) || 0;
  const payable = Number(data?.summary?.total_payable) || 0;
  const remaining = payable - paid;
  const paidPercentage = payable > 0 ? (paid * 100) / payable : 0;

  const rows = [
    { label: lbl.Payable, value: payable, color: "#EF9C0E" },
    { label: lbl.Paid, value: paid, color: "#48C29D" },
    { label: "بیلانس", value: remaining, color: "#9A3859" },
  ];

  return data ? (
    <div className="print-finance-chart-wrap">
      <PrintFinanceBars
        rows={rows}
        percentLabel={lbl.PaidPercentage}
        percent={paidPercentage}
      />
    </div>
  ) : null;
};

export default Chart;
